import React from 'react';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import type { TouchpointIdType } from '../../types.tsx';
import { DialogContent } from '../dialog-content/async.tsx';

type Props = {
	touchpointId: TouchpointIdType;
};

export const UpFlowApp = ({ touchpointId }: Props) => {
	const props = {
		touchpointId,
		isOpen: true,
		// Replace with lodash/noop
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onUpFlowDismiss: () => {},
	};

	return (
		<AppBase>
			<DialogContent {...props} />
		</AppBase>
	);
};
